import IllumioDomUtils from "../common/dom_utils.js";
import IllumioSupportUtils from "../common/support_utils.js";
import SoftwareUtils from "./common-utils.js";
import { CommonSoftwareModel, CommonSoftwareView, CommonSoftwareController } from "./common-software-mvc.js";
import { SoftwareUpgradePathModel, SoftwareUpgradePathView, SoftwareUpgradePathController } from "./upgrade-path-mvc.js";

/**********************************************************************
 * Software Upgrade MVC
 *********************************************************************/

// Inherit CommonSoftwareModel
export class SoftwareUpgradeModel extends CommonSoftwareModel {
    constructor(filename) {
        super(filename);

        this.fromVersion = '21.2.1';
        this.toVersion = null;

        this.displayVersions = null;
    }

    // Object.defineProperty(SoftwareUpgradeModel, 'constructor', {
    //     value: SoftwareUpgradeModel,
    //     enumerable: false,
    //     writable: true,
    // });
    // SoftwareUpgradeModel.prototype = Object.create(CommonSoftwareModel.prototype);
}

export class SoftwareUpgradeView extends CommonSoftwareView {
    constructor(model) {
        super(model);

        // this.upgradeFormSubmitEvent = new IllumioEvent(this);
        // this.renderUpgradePathEvent = new IllumioEvent(this);

        this.elements = SoftwareUtils.createChildrenCache([ 'introductory', 'resources', 'upgrade_form', 'upgrade_path', 'error', 'eula', 'download', 'resources-mobile' ]);
        // Notes: this.elements['downloadFormElement'] will be added later.

        // Render the upgrade form for the first time.
        this.renderUpgradeForm();
    }

    // Object.defineProperty(SoftwareUpgradeView, 'constructor', {
    //     value: SoftwareUpgradeView,
    //     enumerable: false,
    //     writable: true,
    // });

    // SoftwareUpgradeView.prototype = Object.create(CommonSoftwareView.prototype);

    /**
     * Public method
     */
    renderResult() {
        // console.debug('SoftwareUpgradeView: renderResult(): ');
        // console.debug(this.model);
        // console.debug('this is the introdcutory element')
        // console.debug(this.elements['introductory'])

        // const metaDataLength = Object.keys(this.model.metadata).length
        // console.debug('this is the model metadata length')
        // console.debug(metaDataLength)

        const metadataSaaS = this.model.metadata.saas_only;
        if (metadataSaaS){
            this.elements['introductory'].textContent = 'Use this tool to determine the supported upgrade path for Illumio VENs.'
        }

        // if (metaDataLength == 5 ){
        // }

        this.elements['introductory'].classList.remove('hidden');
        this.elements['upgrade_form'].classList.remove('hidden');

        this.populateSelectElementsOptions();

        if (this.model.fromVersion && this.model.toVersion) {
            this.renderUpgradePath();
        }
    }

    /**
     * Public method
     */
    renderUpgradePath() {
        console.debug('SoftwareUpgradeview: renderUpgradePath() ');
        // this.renderUpgradePathEvent.notify();
        this.emit('renderUpgradePath', {});
    }

    /**
     * Public method
     */
    toggleErrorElement(displayErrorElement) {
        if (displayErrorElement) {
            this.elements['error'].classList.remove('hidden');
        } else {
            this.elements['error'].classList.add('hidden');
        }

        const resultElementNames = [ 'upgrade_path', 'eula', 'download' ];
        const resultElementNamesForEachHandler = function(resultElementName) {
            if (displayErrorElement) {
                this.elements[resultElementName].classList.add('hidden');
            } else {
                this.elements[resultElementName].classList.remove('hidden');
            }
        }
        resultElementNames.forEach(resultElementNamesForEachHandler.bind(this));

        // IllumioSupportTemplate.resetContentHeight();
    }

    /** 
     * Public method
     */
    renderNoUpgradePathError(fromVersionLabel, toVersionLabel) {
        const errorMessage = [];
        errorMessage.push('There is no upgrade path from ');
        errorMessage.push(fromVersionLabel);
        errorMessage.push(' to ');
        errorMessage.push(toVersionLabel);
        errorMessage.push('.');
        this.elements['error'].textContent = errorMessage.join('');

        this.toggleErrorElement(true);
    }
    
    /**
     * Public method
     */
    renderUpgradePathTooOld() {
        this.elements['error'].innerHTML = '<span style="color:black">Please contact Illumio Support at <a href="mailto:support@illumio.com">support@illumio.com</a> for assistance with your upgrade</span>';

        this.toggleErrorElement(true);
    }

    /**
     * A utlity function populates both fromVersion and toVersion select element.
     * This should be a one-time invoke.
     */
    populateSelectElementsOptions() {
console.debug(this.elements);
console.debug(this.elements['downloadFormElement']);
        IllumioDomUtils.populateSelectOptions(this.elements['downloadFormElement'].from_version, this.model.data.upgrade_from_options, this.model.fromVersion);

        IllumioDomUtils.removeChildren(this.elements['downloadFormElement'].to_version);
        IllumioDomUtils.populateSelectOptions(this.elements['downloadFormElement'].to_version, this.filterToOptions(this.model.fromVersion), this.model.toVersion);
    }

    filterToOptions(fromVersion) {
        const filteredToOptions = [];

        if (this.model.data.upgrade_to_options) {
            var toOptionsForEachHandler = function(toOption) {
                if ((fromVersion && fromVersion<toOption[0]) || !fromVersion) {
                    filteredToOptions.push(toOption);
                }
            }
            this.model.data.upgrade_to_options.forEach(toOptionsForEachHandler.bind(this));
        }

        return filteredToOptions;
    }

    selectOnChangeHandler(event) {
        console.debug(this);
        console.debug(event.target);
        console.debug(event.target.id);

        if (event.target.name==='from_version') {
            IllumioDomUtils.removeChildren(this.elements['downloadFormElement'].to_version);
            IllumioDomUtils.populateSelectOptions(this.elements['downloadFormElement'].to_version, this.filterToOptions(event.target.value), this.model.toVersion);
        }

        // Enable the submit button if meeting the criteria.
        if (event.target && event.target.form) {
            const formElement = event.target.form;
            const submitElement = SoftwareUtils.getFormSubmitButton(formElement);
            if (submitElement && formElement['from_version'] && formElement['from_version'].selectedIndex>0 && formElement['to_version'] && formElement['to_version'].selectedIndex>0) {
                submitElement.disabled = false;
            } else {
                submitElement.disabled = true;
            }
        }
    }

    upgradeFormSubmitHandler(event) {
        event.preventDefault();

        // this.upgradeFormSubmitEvent.notify(event.target);
        this.emit('upgradeFormSubmit', { theForm: event.target });
    }

    renderUpgradeForm() {
        const fieldLabels = [ 'From Version', 'To Version' ];

        const nameSpace = SoftwareUtils.getCurrentContentId();

        const formElement = document.createElement('form');
        formElement.classList.add('ilo-form');
        formElement.classList.add('upgrade-form');
        formElement.onsubmit = this.upgradeFormSubmitHandler.bind(this);

        const fieldLabelsForEachHandler = function(fieldLabel) {
            console.debug(fieldLabel);
            const id = IllumioSupportUtils.camelCaseWords(fieldLabel);
            const fieldName = fieldLabel.toLowerCase().replace(/\s+/g, '_');

            const labelElement = document.createElement('label');
            labelElement.htmlFor = nameSpace + id;
            labelElement.appendChild(document.createTextNode(fieldLabel + ': '));
            labelElement.appendChild(IllumioDomUtils.createSimpleTextBlock('span', '*', 'required'));

            const selectElement = document.createElement('select');
            selectElement.classList.add('select');
            selectElement.name = fieldName;
            selectElement.id = labelElement.htmlFor;
            selectElement.required = true;
            selectElement.onchange = this.selectOnChangeHandler.bind(this);

            const divElement = document.createElement('div');
            divElement.appendChild(labelElement);
            divElement.appendChild(selectElement);

            formElement.appendChild(divElement);

            console.debug(formElement);
            console.debug(this);
        }
        fieldLabels.forEach(fieldLabelsForEachHandler.bind(this));

        const submitInputElement = document.createElement('input');
        submitInputElement.type = 'submit';
        submitInputElement.classList.add('btn');
        submitInputElement.classList.add('btn-primary');
        submitInputElement.value = 'Find My Upgrade Path »';
        submitInputElement.disabled = true;

        formElement.appendChild(submitInputElement);

        if (this.elements['upgrade_form'] && this.elements['upgrade_form'].tagName==='DIV') {
            this.elements['upgrade_form'].classList.remove('hidden');
            this.elements['upgrade_form'].appendChild(formElement);
            this.elements['downloadFormElement'] = formElement;
        }
console.debug(`renderUpgradeForm():`);
console.debug(formElement);
console.debug(this.elements['upgrade_form']);
    }
}

export class SoftwareUpgradeController extends CommonSoftwareController {
    constructor(model, view) {
        super(model, view);

        // this.view.upgradeFormSubmitEvent.attach(upgradeFormSubmitEventHandler.bind(this));
        // this.view.renderUpgradePathEvent.attach(renderUpgradePathEventHandler.bind(this));
        this.view.on('upgradeFormSubmit', this.upgradeFormSubmitEventHandler.bind(this));
        this.view.on('renderUpgradePath', this.renderUpgradePathEventHandler.bind(this));

        this.initializeSoftwareUpgradePath();

        this.detectToFromVersions();
    }

    initializeSoftwareUpgradePath() {
        const softwareUpgradePathModel = new SoftwareUpgradePathModel();
        const softwareUpgradePathView = new SoftwareUpgradePathView(softwareUpgradePathModel);
        softwareUpgradePathView.upgradePathElement = this.view.elements['upgrade_path'];
        this.softwareUpgradePathController = new SoftwareUpgradePathController(softwareUpgradePathModel, softwareUpgradePathView);
    }

    upgradeFormSubmitEventHandler(payload) {
        console.debug(this);
        const formElement = (payload && payload.theForm) ? payload.theForm : null;
        if (formElement) {
            console.debug(formElement);
            
            this.model.fromVersion = formElement.from_version.value;
            this.model.toVersion = formElement.to_version.value;
            console.debug('SoftwareUpgradeController: upgradeFormSubmitEventHandler(): this.model.fromVersion: ' + this.model.fromVersion);
            console.debug('SoftwareUpgradeController: upgradeFormSubmitEventHandler(): this.model.toVersion: ' + this.model.toVersion);

            const hashParts = location.hash.substring(1).split('/');
            if (hashParts.length==2) {
                hashParts.push(this.model.fromVersion);
                hashParts.push(this.model.toVersion);
            } else if (hashParts.length==4) {
                hashParts[2] = this.model.fromVersion;
                hashParts[3] = this.model.toVersion;
            }

            if (hashParts.length==2 || hashParts.length==4) {
                location.hash = hashParts.join('/');
                console.debug('SoftwareUpgradeController: upgradeFormSubmitEventHandler(): Change location.hash to ' + hashParts.join('/'));
            } else {
                console.warn('SoftwareUpgradeController: upgradeFormSubmitEventHandler(): Hash parts does not meet the expected size.');
            }
        } else {
            console.warn(`The formElement is missing!`);
        }
    }

    renderUpgradePathEventHandler() {
        console.debug('SoftwareUpgradeController: renderUpgradePathEventHandler()');

        let software_type = 'tar'
        if (this.model.metadata.product == 'VEN') {
            software_type = 'ven'
        }

        this.model.displayVersions = this.softwareUpgradePathController.view.render(software_type, this.model.fromVersion, this.model.toVersion);

        if (this.model.fromVersion < '17.1.0') {
            this.view.renderUpgradePathTooOld();
        } else if (this.model.displayVersions) {
            this.view.toggleErrorElement(false);
            this.view.renderDownloads();
        } else {
            this.view.renderNoUpgradePathError(this.model.fromVersion, this.model.toVersion);
        }
    }

    detectToFromVersions() {
        if (location.hash) {
            const hashParts = location.hash.substring(1).split('/');
            if (hashParts.length>=4) {
                this.model.fromVersion = hashParts[2];
                this.model.toVersion = hashParts[3];
                var upgradeFormSubmitButton = SoftwareUtils.getFormSubmitButton(this.view.elements['downloadFormElement']);
                if (upgradeFormSubmitButton) {
                    upgradeFormSubmitButton.disabled = false;
                }
            }
        }
        console.debug('SoftwareUpgradeController: detectToFromVersions(): this.model.fromVersion: ' + this.model.fromVersion);
        console.debug('SoftwareUpgradeController: detectToFromVersions(): this.model.toVersion: ' + this.model.toVersion);
    }
}
